import { createSlice } from '@reduxjs/toolkit';
export const initialState = {};
export const portalAttributesSlice = createSlice({
  name: 'portalAttributes',
  initialState,
  reducers: {
    updateAttribute: (state, action) => {
      state[action.payload.key] = action.payload.value;
    }
  }
});
export const getPortalAttributes = state => state.portalAttributes;
export const {
  updateAttribute
} = portalAttributesSlice.actions;
export default portalAttributesSlice.reducer;